export const Colors = {
  primary: "#041c5c",
  secondry: "#82bd01",
  main: "#001529",
};
